var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.6001 8.5694L6.74343 10.1839C6.7868 10.2483 6.84501 10.3016 6.91323 10.3391C6.98144 10.3767 7.05768 10.3975 7.1356 10.3998C7.21353 10.4021 7.29088 10.3859 7.36122 10.3524C7.43157 10.319 7.49287 10.2693 7.54003 10.2076L10.8001 6",
    stroke: "#3CAE8B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.6001 8.0001C1.6001 9.69748 2.27438 11.3253 3.47461 12.5256C4.67485 13.7258 6.30271 14.4001 8.0001 14.4001C9.69748 14.4001 11.3253 13.7258 12.5256 12.5256C13.7258 11.3253 14.4001 9.69748 14.4001 8.0001C14.4001 6.30271 13.7258 4.67485 12.5256 3.47461C11.3253 2.27438 9.69748 1.6001 8.0001 1.6001C6.30271 1.6001 4.67485 2.27438 3.47461 3.47461C2.27438 4.67485 1.6001 6.30271 1.6001 8.0001Z",
    stroke: "#3CAE8B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkGreen);
export default __webpack_public_path__ + "static/media/checkmark-green.974b6c31f2521ad5d2dd4db2e049da9a.svg";
export { ForwardRef as ReactComponent };